export default "__VITE_ASSET__4dvEmIyN__"